module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_6005.f5831bca.png";